import React from 'react';
import { IMembersDataModalProps } from './types';
import { Modal, Typography } from '@loophealth/loop-ui-web-library';
import { StyledEnrolledMemberContent, StyledModalContainer, StyledModalContent } from './styles';
import EnrolledMemberRow from './EnrolledMemberRow';
import { getEnroledMembersString } from './utils';
import MobileBackButton from '../../atoms/MobileBackButton';
const EnrolledMemberModal: React.FunctionComponent<IMembersDataModalProps> = ({
    dependents,
    isCollapsed,
    isVisible,
    setIsVisible,
    dependentsInsured,
    isTopUpPolicy
}) => {
    return (
        <StyledEnrolledMemberContent $isCollapsed={isCollapsed} data-testid="enrol-members-modal">
            <Modal title={'Registered Members'} isVisible={isVisible} setIsVisible={setIsVisible} mobileBottomSheet>
                <MobileBackButton onClick={() => setIsVisible(false)} />
                <StyledModalContainer data-testid="enrol-members-modal-container">
                    <StyledModalContent>
                        <Typography variant="small" color="secondary" weight="semiBold">
                            {getEnroledMembersString(dependents?.length, dependentsInsured, isTopUpPolicy ?? false)}
                            {' eligible members registered'}
                        </Typography>
                        {dependents.map((dep, index) => (
                            <EnrolledMemberRow key={index} index={index} {...dep} />
                        ))}
                    </StyledModalContent>
                </StyledModalContainer>
            </Modal>
        </StyledEnrolledMemberContent>
    );
};

export default EnrolledMemberModal;
